module.exports = __webpack_public_path__ + "img/hide_lesson.63169c55.svg";